function choicesAutoComplete(el) {

    var self = this;
    self.url = el.dataset.url || '/tags';
    self.el = el;
    self.allowNew = el.dataset.allowNew === 'true';
    self.choices = new Choices(el, {
        addItems: true, removeItemButton: true,
        placeholderValue: '',
        searchPlaceholderValue: 'Search',
        loadingText: 'Loading...',
        noResultsText: '<span class="spinner"><i class="fa fa-spinner fa-spin"></i>Loading...</span><span class="noresults">No results match your search.</span>',
        noChoicesText: 'Begin typing to search...',
        itemSelectText: 'Press enter to select',
        addItemText: function (value) {
            return 'Press Enter to add <b>"${value}"</b>';
        },
        maxItemText: function (maxItemCount) {
            return 'Only ${maxItemCount} values can be added.';
        }
    });

    el.addEventListener('change', function (evt) {
        //Set bound value based on UI changes.
        window.setTimeout(function () {

            self.choices.hideDropdown();
            self.choices.clearInput();
            self.choices.setChoices([], 'id', 'text', true);
        }, 100);
    });

    el.addEventListener('search', function (evt) {
        self.choices.choiceList.classList.add('loading');

        var searchTerm = (evt.detail.value + '').toLowerCase();
        if (self.searchtimeout) window.clearTimeout(self.searchtimeout);
        if (self.cancelTokenSource) self.cancelTokenSource.cancel();
        self.cancelToken = axios.CancelToken;
        self.cancelTokenSource = self.cancelToken.source();
        self.searchtimeout = window.setTimeout(function () {
            axios.get(self.url + '?search=' + evt.detail.value, { cancelToken: self.cancelTokenSource.token })
                .then(function (res) {
                    var data = res.data;
                    var hasMatch = false;
                    for (var i = 0; i < data.length; i++) {
                        var tag = data[i];
                        data[i].customProperties = data[i];
                        if (tag.text.toLowerCase() === searchTerm) {
                            hasMatch = true;
                            break;
                        }
                    }
                    
                    if (!hasMatch && self.allowNew) {
                        data.push({ id: 0 - new Date().valueOf(), text: evt.detail.value.replace(/ /g, '-').toLowerCase() }); // 0 - new Date().valueOf() is used because choices.js set to prevent duplicates by id.  This allows multiple new tags, but still prevents dupes for existing tags
                    }
                    self.choices.setChoices(data, 'id', 'text', true);
                    self.choices.choiceList.classList.remove('loading');
                    // if (data.length == 0) self.choices.hideDropdown();
                }).catch(function (ex) {
                    self.choices.choiceList.classList.remove('loading');
                });
        }, 400);
    });

    return self;
}

